var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadphone = function SvgHeadphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.618 6.667h.885c.92 0 1.666.747 1.666 1.667v3.333c0 .92-.746 1.667-1.666 1.667h-.885a6.67 6.67 0 0 1-6.615 5.833v-1.666a5 5 0 0 0 5-5v-5a5 5 0 0 0-10 0v5.833h-2.5c-.92 0-1.667-.746-1.667-1.667V8.334c0-.92.746-1.667 1.667-1.667h.885a6.668 6.668 0 0 1 13.23 0M2.503 8.334v3.333h.833V8.334zm14.166 0v3.333h.834V8.334zm-10.2 4.82.883-1.413c.769.482 1.677.76 2.65.76.974 0 1.883-.278 2.65-.76l.884 1.414a6.64 6.64 0 0 1-3.533 1.012c-1.298 0-2.51-.37-3.534-1.012"
  })));
};
export default SvgHeadphone;